import { faker } from "@faker-js/faker/locale/fr"
import type {
  FinancialDataPurchasesChannelsApi,
  FinancialDataPurchasesChannelsContent,
} from "../../purchases"

const TOTAL_ELEMENTS = 40
const RANK_STEP = 20_000

const purchasesChannelLaboratoryMock = (
  rank: number,
): FinancialDataPurchasesChannelsContent => ({
  laboratoryId: faker.number.int({ min: 1, max: 9_999 }),
  laboratoryName: faker.company.name(),
  purchases: {
    mainStat:
      (TOTAL_ELEMENTS - rank + 1) * RANK_STEP +
      faker.number.float({ min: 0, max: RANK_STEP - 1, fractionDigits: 2 }),
    evolution: faker.number.float({ min: -100, max: 100, fractionDigits: 1 }),
  },
  discounts: {
    total: faker.number.float({ min: 0, max: 99_999, fractionDigits: 2 }),
    percentage: faker.number.float({ min: 0, max: 100, fractionDigits: 1 }),
  },
  purchasesWeight: {
    mainStat: faker.number.float({ min: 0, max: 100, fractionDigits: 1 }),
    evolution: faker.number.float({ min: -10, max: 10, fractionDigits: 1 }),
  },
  rank,
})

export const purchasesChannelsMock = (
  page = 0,
  size = 15,
): FinancialDataPurchasesChannelsApi => {
  const first = page * size
  const count = Math.max(0, Math.min(size, TOTAL_ELEMENTS - first))

  return {
    content: Array.from({ length: count }, (_, index) =>
      purchasesChannelLaboratoryMock(first + index + 1),
    ),
    number: page,
    size,
    totalElements: TOTAL_ELEMENTS,
    totalPages: Math.ceil(TOTAL_ELEMENTS / size),
  }
}
